import React, { useEffect, useState } from 'react';

import { Asset, AssetsKeys } from 'hooks/useAssets/useAssets.types';
import { useAssets } from 'hooks/useAssets/useAssets';

import { UsageReport } from './UsageReport';
import { UsageReportFilters } from './UsageReport.types';

const ifContainText = (field: string | number | undefined, value: string): boolean => {
  return !!field && field.toString().toLowerCase().indexOf(value.toLowerCase()) > -1;
};

export const UsageReportContainer = () => {
  const { assets, getAssets } = useAssets();
  const [filteredAssets, setFilteredAssets] = useState<Asset[]>(assets ?? []);

  useEffect(() => {
    getAssets();
  }, [getAssets]);

  const onFiltersChange = (filters: UsageReportFilters) => {
    if (assets) {
      setFilteredAssets(
        assets.filter(battery => {
          return ['origin', 'id', 'manufacturer'].reduce((result: boolean, field: string) => {
            return result || ifContainText(battery[field as AssetsKeys] as string, filters.search);
          }, false);
        }),
      );
    }
  };

  return <UsageReport batteryList={filteredAssets} onFiltersChange={onFiltersChange} />;
};
